import { CircleHelp } from "lucide-react-native";
import { FC, useState } from "react";
import { createPortal } from "react-dom";

export interface InfoTipProps {
  text: string;
}

const WIDTH = 260;

/** Small "?" icon that explains a concept on hover (web). */
const InfoTip: FC<InfoTipProps> = ({ text }) => {
  const [position, setPosition] = useState<{ x: number; y: number } | null>(
    null
  );

  const show = (event: React.MouseEvent<HTMLSpanElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPosition({ x: rect.left + rect.width / 2, y: rect.bottom + 6 });
  };

  return (
    <>
      <span
        onMouseEnter={show}
        onMouseLeave={() => setPosition(null)}
        style={{
          alignItems: "center",
          cursor: "help",
          display: "inline-flex",
          padding: 2,
        }}
      >
        <CircleHelp color="rgb(var(--color-typography-400))" size={13} />
      </span>
      {position &&
        createPortal(
          <div
            style={{
              background: "rgb(var(--color-background-900))",
              borderRadius: 6,
              color: "rgb(var(--color-typography-50))",
              fontFamily: "inherit",
              fontSize: 12,
              left: Math.max(
                8,
                Math.min(position.x - WIDTH / 2, window.innerWidth - WIDTH - 8)
              ),
              lineHeight: "16px",
              padding: "8px 12px",
              pointerEvents: "none",
              position: "fixed",
              top: position.y,
              width: WIDTH,
              zIndex: 10000,
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export default InfoTip;
